import { html } from 'lit';
const MultiCursorDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#6E52DF" d="M3.03 5.302c-.278-1.606 1.41-2.832 2.851-2.07l13.518 7.14c1.542.815 1.336 3.086-.328 3.609l-5.526 1.736a1.96 1.96 0 0 0-1.01.734L9.17 21.174c-1.012 1.421-3.236.915-3.534-.804z"/><path stroke="#000" stroke-opacity=".1" d="M3.523 5.217c-.207-1.197 1.051-2.11 2.125-1.543l13.518 7.14c1.149.608.995 2.3-.245 2.69l-5.526 1.736c-.512.161-.957.484-1.268.921l-3.363 4.723c-.754 1.059-2.412.682-2.634-.599z"/>
  </svg>
`;
export default MultiCursorDuotone;
